
import objMixin from './objMixin';
import CrmRelative from '@/components/CreateCom/CrmRelative';

export default {
  name: 'XhProduct', // 关联产品
  components: {
    CrmRelative: CrmRelative
  },
  mixins: [objMixin],
  props: {},
  data: function data() {
    return {
      showPopover: false, // 展示产品框
      showSelectView: false, // 内容
      productList: [],
      total_price: 0,
      discount_rate: '',
      selectedData: { product: [] }
    };
  },

  computed: {},
  watch: {
    dataValue: function dataValue(value) {
      this.refreshProductList();
    },
    productList: function productList() {
      this.selectedData = { product: this.productList || [] };
    }
  },
  mounted: function mounted() {
    this.refreshProductList();
  },

  methods: {
    /**
     * 刷新数据
     */
    refreshProductList: function refreshProductList() {
      this.productList = this.dataValue.product || [];
      this.total_price = this.dataValue.total_price || 0;
      this.discount_rate = this.dataValue.discount_rate || '';
    },

    /** 选中 */
    selectInfos: function selectInfos(data) {
      var _this = this;

      if (data.data) {
        var newSelects = [];
        data.data.forEach(function (element) {
          var obj = _this.productList.find(function (item) {
            return item.product_id == element.product_id;
          });
          if (obj) {
            newSelects.push(obj);
          } else {
            newSelects.push(_this.getShowItem(element));
          }
        });
        this.productList = newSelects;
        this.calculateToal();
      }
    },
    getShowItem: function getShowItem(data) {
      var item = {};
      item.name = data.name;
      item.category_id_info = data.category_id_info;
      item.unit = data.unit;
      item.price = data.price || 0;
      item.sales_price = data.price || 0;
      item.num = 1;
      item.discount = 0;
      item.subtotal = data.price || 0;
      item.product_id = data.product_id;
      return item;
    },

    // 单价
    salesPriceChange: function salesPriceChange(data) {
      var item = data.row;

      var discount = (item.price - item.sales_price || 0) / item.price * 100.0;
      discount = discount.toFixed(2);
      if (item.discount !== discount) {
        item.discount = discount;
      }
      this.calculateSubTotal(item);
      this.calculateToal();
    },

    // 数量
    numChange: function numChange(data) {
      var item = data.row;
      this.calculateSubTotal(item);
      this.calculateToal();
    },

    // 折扣
    discountChange: function discountChange(data) {
      var item = data.row;
      var sales_price = item.price * (100.0 - parseFloat(item.discount || 0)) / 100.0;
      sales_price = sales_price.toFixed(2);
      if (item.sales_price !== sales_price) {
        item.sales_price = sales_price;
      }
      this.calculateSubTotal(item);
      this.calculateToal();
    },

    // 计算单价
    calculateSubTotal: function calculateSubTotal(item) {
      item.subtotal = (item.sales_price * parseFloat(item.num || 0)).toFixed(2);
    },

    // 计算总价
    calculateToal: function calculateToal() {
      var total_price = this.getProductTotal();
      total_price = total_price * (100.0 - parseFloat(this.discount_rate || 0)) / 100.0;
      this.total_price = total_price.toFixed(2);
      this.updateValue(); // 传递数据给父组件
    },

    /**
     * 获取产品总价(未折扣)
     */
    getProductTotal: function getProductTotal() {
      var total_price = 0.0;
      for (var i = 0; i < this.productList.length; i++) {
        var item = this.productList[i];
        total_price += parseFloat(item.subtotal);
      }
      return total_price;
    },

    // 总折扣
    rateChange: function rateChange() {
      this.calculateToal();
    },

    /**
     * 总价更改 折扣更改
     */
    totalPriceChange: function totalPriceChange() {
      var total_price = this.getProductTotal();
      if (total_price) {
        this.discount_rate = (100.0 - parseFloat(this.total_price) / total_price * 100).toFixed(2);
      }
      this.updateValue();
    },

    // 删除操作
    removeItem: function removeItem(index) {
      this.productList.splice(index, 1);
      this.calculateToal();
    },
    updateValue: function updateValue() {
      this.valueChange({
        product: this.productList,
        total_price: this.total_price,
        discount_rate: this.discount_rate
      });
    }
  }
};